// extracted by mini-css-extract-plugin
export default {"card":"q3-z","carouselContainer":"r3-z","carouselContent":"s3-z"};